<template>
  
  <div class="">
    <transition><router-view></router-view></transition>
  </div>
</template>

<script>

export default {
name: "App",

components: {},

methods: {},

mounted() {},

};

</script>

<style scoped>
.v-enter-active {
  /* transition: all 0.3s ease-out; */
  animation: slide-fade .8s ease-out;
}
.v-leave-active {
  /* transition: all 0.3s ease-in; */
  animation: slide-fade .8s ease-out;
}
.animate {
  /* transform: translateX(-100px); */
  animation: slide-fade 0.5s forwards;
}

@keyframes slide-fade {
  0% {
    /* transform: translateX(0) scale(1); */
    opacity: 0;
  }

  70% {
    /* transform: translateX(-120px) scale(1.1); */
    opacity: .5;
  }

  100% {
    /* transform: translateX(-150px) scale(1); */
    opacity: 1;
  }
}
</style>

